import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import RoleManagementContainer from 'app/containers/HumanResources/RoleManagement'

const RoleManagementPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.role_management)}</PageTitle>
      <RoleManagementContainer />
    </>
  )
}
const RoleManagementPage = memo(RoleManagementPageCpn, isEqual)

export default RoleManagementPage
